import {ZIP_DOWN_PROG} from "./actionTypes";

export const zipFileDownloadProgress = (prog) => {
    return {
        type: ZIP_DOWN_PROG,
        'payload': prog
    }
};